import React from 'react'
import { SidebarNavigation } from './SidebarNavigation'
import styled from 'styled-components'
import { OutputtedCardList } from './OutputedCardList'
import { BreadCrambs } from './BreadCrambs'

const Container = styled.section`
    padding: 0 5rem;

    @media (min-width: 768px) and (max-width: 960px) {
        padding: 0 0 0 5rem;
    }
    @media (max-width: 320px) {
        padding: 0 2rem;
    }

    .section-body {
        margin-top: 2rem;
        display: flex;

        @media (max-width: 767.98px) {
            justify-content: center;
        }    
    }
`

export const Products = () => {

    return (
        <Container >
                <BreadCrambs />
                <div className="section-body">
                    <SidebarNavigation />
                    <OutputtedCardList />
                </div>
        </Container>
    )
}
